import styled from 'styled-components';
import { black } from 'constants/color';

export const StyledWrapper = styled.div`
  overflow-x: hidden;
  margin-right: 10px;

  /* Mobile Devices */
  @media (max-width: 480px) {
    max-height: calc(calc(${({ theme }) => theme.mobileViewHeight}) - 2rem);
  }

  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    max-height: 950px;
  }
`;

export const StyledRow = styled.div`
  display: flex;
  margin-right: 0;
  margin-left: -15px;
  margin-bottom: 10px;

  /* Mobile Devices */
  @media (max-width: 480px) {
    margin-bottom: 0;
    margin-right: 15px;
    padding-right: 15px;
    flex-direction: column;
  }

  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    margin-bottom: 0;
    margin-right: 15px;
    padding-right: 15px;
    flex-direction: column;
  }
`;

export const StyledRowItem = styled.div`
  width: 50%;
  min-height: 1px;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;

  /* Mobile Devices */
  @media (max-width: 480px) {
    width: 100%;
    margin-bottom: 10px;
  }

  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
    margin-bottom: 10px;
  }
`;

export const PackageWrapper = styled.div`
  font-size: 13px;
  margin-left: 10px;
  font-weight: normal;
`;

export const PackageUsage = styled.div`
  font-size: 13px;
  font-weight: normal;
`;

export const PackageInfo = styled.span`
  color: ${black};
  font-size: 13px;
  margin-left: 10px;
  font-weight: normal;
`;
